export function ClockFormatSelector( {is24hFormat, onClockFormatChange} ) {

    return (
      <div className="custom-control custom-checkbox">
        <input type="checkbox" className="custom-control-input"
          id="customSwitch1"  checked={is24hFormat} onChange={onClockFormatChange}/>
          <label className="custom-control-label" htmlFor="customSwitch1">24-hour</label>
      </div>

    );
}